// extracted by mini-css-extract-plugin
export var accordionWrapper = "l_W";
export var addTransition = "l_X";
export var content = "l_Y";